import { Outlet } from '@tanstack/react-router'
import { BottomNav } from './BottomNav'
import { InstallPrompt } from './InstallPrompt'

/* Spec PWA-001 — casca das abas (Inicio, Mensagens, Doar, Impacto, Conta, Criancas): conteudo + barra inferior.
   Em telas largas (>= lg) a barra some (menu lateral no AuthLayout) e o conteudo ganha largura. */
export function AppShell() {
    return (
        <div className="min-h-dvh bg-app-background">
            <main className="mx-auto w-full max-w-lg pb-[calc(5.5rem+var(--spacing-safe-bottom))] lg:max-w-6xl lg:px-6 lg:pt-6 lg:pb-12">
                <Outlet />
            </main>
            <BottomNav />
            <InstallPrompt />
        </div>
    )
}
